// extracted by mini-css-extract-plugin
export default {"faqSection":"FAQ_faqSection__cfj28","title":"FAQ_title__JRsuB"};